import { useSyncExternalStore } from 'react'
import type { ReactNode } from 'react'

const subscribe = () => () => {}

/**
 * Renders children only on the client, after hydration. On the server, and on
 * the very first client render (so hydration matches), it renders `fallback`.
 *
 * Wrap anything that must not run during prerender: WebGL shaders, or code that
 * touches window/document/canvas at render time. The visible content around it
 * still server-renders, so SEO and first paint are unaffected.
 */
export function ClientOnly({
  children,
  fallback = null,
}: {
  children: ReactNode
  fallback?: ReactNode
}) {
  const isClient = useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  )
  return <>{isClient ? children : fallback}</>
}
